import { motion } from 'framer-motion';
import { PRACTICES } from './data';
// PRACTICE — four numbered chapters, dossier rule lines.
export default function Practice({ setPage }) {
  return (
    <div className="bg-[#E8DCC1] text-[#1F1B17] relative">
      <div className="absolute inset-0 opacity-[0.04] pointer-events-none" style={{ backgroundImage: 'radial-gradient(#1F1B17 1px, transparent 1px)', backgroundSize: '20px 20px' }} />
      <section className="relative pt-14 pb-10 max-w-[1500px] mx-auto px-8 lg:px-14 border-b-2 border-[#5C1F1A]/30">
        <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#5C1F1A] mb-3">— Folio I / Practice areas</p>
        <h1 className="font-serif text-[44px] lg:text-[88px] leading-[0.92] text-[#5C1F1A]">Four <span className="italic text-[#1F1B17]">chambers</span>.</h1>
      </section>
      <section className="relative max-w-[1300px] mx-auto px-8 lg:px-14 py-16 space-y-1">
        {PRACTICES.map((p, i) => (
          <motion.article key={p.ref} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} transition={{ delay: i * 0.06 }}
            className="grid grid-cols-[80px_1fr] lg:grid-cols-[140px_1fr_220px] gap-6 lg:gap-12 py-10 border-t-2 border-[#5C1F1A]/20">
            <div>
              <p className="font-mono text-[10px] tracking-[0.4em] uppercase text-[#5C1F1A]">{p.ref}</p>
              <p className="font-serif text-7xl lg:text-8xl text-[#5C1F1A] leading-none">{['I','II','III','IV'][i]}</p>
            </div>
            <div>
              <h2 className="font-serif text-3xl lg:text-5xl leading-[1] text-[#5C1F1A]" dangerouslySetInnerHTML={{ __html: p.t }} />
              <p className="font-serif text-base lg:text-lg text-[#1F1B17]/85 leading-[1.7] mt-4 max-w-2xl" dangerouslySetInnerHTML={{ __html: p.d }} />
            </div>
            <div className="lg:border-l border-[#5C1F1A]/20 lg:pl-6">
              <p className="font-mono text-[10px] tracking-[0.3em] uppercase text-[#B68F4E] mb-2">Lead counsel</p>
              <p className="font-serif italic text-xl text-[#1F1B17]">{p.led}</p>
              <button onClick={() => setPage('inquiry')} className="mt-4 font-mono text-[10px] tracking-[0.3em] uppercase border-b border-[#5C1F1A] text-[#5C1F1A] pb-0.5 hover:text-[#B68F4E] hover:border-[#B68F4E]" data-testid={`law-practice-${p.ref}`}>Inquire →</button>
            </div>
          </motion.article>
        ))}
      </section>
    </div>
  );
}
